import React from 'react';
import BannerTemplate from "../../components/templates/BannerTemplate";
import {BannerType} from "../../../types/banner";

export const BannerAdd = () => <BannerTemplate type={'ADD'} bannerType={BannerType.MAIN}/>;